/**
 * User: WangMeng
 * Date: 2018-07-18
 * Time: 16:36
 * Desc: 隐患详情基本class
 */

import React, { PureComponent } from 'react';
import { Table } from 'antd';
import { commonRequest } from '../commons';
import { isArray, addUniqueField } from '../../../../utils/util';

export default class BaseDangerDetail extends PureComponent{
    constructor(props) {
        super(props);
    }

    state = {
        loading: false,
        data: []
    };

    searchParam = {

    };

    title = '';

    rowKey = 'index';

    componentDidMount() {
        this.getData();
    }

    // 请求数据
    getData = () => {
        const { server, id } = this.props;
        this.setState({
            loading: true
        });

        server && server(commonRequest({ id })).then(data => {
            this.setState(this.formatResponse(data));
        }).finally(() => {
            this.setState({
                loading: false
            });
        });
    };

    // 根据需求格式化数据，返回state
    formatResponse = (data) => {
        if(data && !isArray(data)) {
            data = [data];
        }
        return {
            data: addUniqueField(data, this.rowKey)
        };
    };

    getColumns = () => {
        return [];
    };

    render() {
        const { loading, data } = this.state;
        return (
            <div>
                <div className="sub-title">{this.title} &nbsp;</div>

                <Table
                    bordered
                    rowKey={this.rowKey}
                    loading={loading}
                    dataSource={data}
                    columns={this.getColumns()}
                    pagination={false}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/common/baseDangerDetail/BaseDangerDetail.jsx